import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import './Auth.css';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MIN_PASSWORD_LENGTH = 6;

const ROLE_ROUTES = {
  admin: '/admin',
  decorator: '/decorator/dashboard',
};

function validateForm({ email, password }) {
  if (!email.trim()) return 'Email daalo';
  if (!EMAIL_REGEX.test(email.trim())) return 'Valid email daalo (e.g. abc@gmail.com)';
  if (!password) return 'Password daalo';
  if (password.length < MIN_PASSWORD_LENGTH) return `Password kam se kam ${MIN_PASSWORD_LENGTH} characters ka hona chahiye`;
  return null;
}

export default function Login() {
  const { login, loading } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    setForm((prev) => ({ ...prev, [field]: value }));
    // Clear field error on change
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Client-side validation
    const validationError = validateForm(form);
    if (validationError) {
      toast.error(validationError);
      return;
    }

    try {
      const result = await login(form.email.trim(), form.password);

      if (!result) {
        toast.error('Server se koi response nahi mila. Dobara try karo.');
        return;
      }

      if (result.success) {
        const role = result.data?.role;
        toast.success('Login successful! 🎉');
        navigate(ROLE_ROUTES[role] ?? '/decorators');
      } else {
        // Show backend error message if available
        const msg = result.message || 'Login fail ho gaya. Dobara try karo.';
        toast.error(msg);
      }
    } catch (err) {
      console.error('Login error:', err);
      toast.error('Kuch gadbad ho gayi. Internet check karo aur dobara try karo.');
    }
  };

  const isFormFilled = form.email.trim() && form.password;

  return (
    <div className="auth-page page">
      <div className="auth-card card">
        <div className="auth-header">
          <div className="auth-logo">🎊</div>
          <h2>Wapas Aao!</h2>
          <p>Apne account me login karo</p>
        </div>

        <form onSubmit={handleSubmit} noValidate>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              className="input"
              type="email"
              placeholder="tumhara@email.com"
              value={form.email}
              onChange={handleChange('email')}
              autoComplete="email"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              className="input"
              type="password"
              placeholder="••••••••"
              value={form.password}
              onChange={handleChange('password')}
              minLength={MIN_PASSWORD_LENGTH}
              autoComplete="current-password"
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', justifyContent: 'center' }}
            disabled={loading || !isFormFilled}
          >
            {loading ? 'Login ho raha hai...' : 'Login Karo'}
          </button>
        </form>

        <p className="auth-footer">
          Account nahi hai? <Link to="/register">Register karo</Link>
        </p>
      </div>
    </div>
  );
}